import type { RouteLocationNormalized, RouteLocationRaw } from 'vue-router'
import { useOnboardingStore } from '../stores/onboardingStore'

/**
 * Метка в query маршрута учебной записи. Учебная форма открывается штатным маршрутом с фиктивным id,
 * и без метки F5, «Назад» браузера или скопированная ссылка открыли бы её вне тура — с запросом на бек по фиктивному id.
 */
export const ONBOARDING_DEMO_QUERY = 'onboarding'

/** Куда увести с маршрута учебной записи, если тур не идёт: на родительский список. Иначе — undefined */
export function resolveStaleDemoRoute(to: RouteLocationNormalized): RouteLocationRaw | undefined {
  if (!(ONBOARDING_DEMO_QUERY in to.query) || useOnboardingStore().isActive)
    return undefined

  const parentName = to.matched.at(-2)?.name

  return parentName ? { name: parentName } : { path: '/' }
}
